import { Button } from '@ps/sports-ui-component-library';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { Message } from '@swf/sports/components';

import {
  TXTWCL_Login,
  TXTWCL_You_must_be_logged_in_to_view__ELL,
  TXTWCL_You_must_be_logged_in_to_view__ELL_1
} from './LoginToViewBets.messages.json';
import styles from './LoginToViewBets.scss';

interface Props {
  historical?: boolean;
}

const LoginToViewBets: React.FC<Props> = ({ historical = false }) => {
  const dispatch = useDispatch<Dispatch>();

  const handleLogin = () => {
    dispatch.modal.enqueue({ path: '/auth/login' });
  };

  return (
    <Message
      message={
        historical ? (
          <Translation {...TXTWCL_You_must_be_logged_in_to_view__ELL_1} />
        ) : (
          <Translation {...TXTWCL_You_must_be_logged_in_to_view__ELL} />
        )
      }
    >
      <div className={styles.buttonWrapper}>
        <Button onClick={handleLogin} className={styles.fullWidth}>
          <Translation {...TXTWCL_Login} />
        </Button>
      </div>
    </Message>
  );
};

export default LoginToViewBets;
